module.exports = __webpack_public_path__ + "img/coins-stacked-03.8f65fb86.svg";